//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchLoader from "../loader/Loader.vue";
import Item from "./Item.vue";
import { format } from "date-fns";

export default {
  name: "BlueResults",
  components: { SearchLoader, Item },
  props: [],
  data() {
    return {};
  },
  computed: {
    results() {
      const curResults = this.$store.getters.results.itemResults;
      const pageLength = this.$store.getters.pageLength;
      let tempArray = [...Array(pageLength)];

      if (this.loaded && !this.reloading && curResults && curResults.length) {
        tempArray = tempArray.map((_, index) => {
          return curResults[index] || null;
        });
      }

      return tempArray;
    },
    hasResults() {
      const totalResultCount = this.$store.getters.results?.totalResultCount || 0;
      return totalResultCount > 0;
    },
    reloading() {
      if (this.options.transitionOnReload) return this.$store.getters.reloading;
      else return false
    },
    loaded() {
      return this.$store.getters.loaded;
    }
  },
  methods: {
    formatDate(date, formatPattern) {
      return format(new Date(date), formatPattern);
    },
    getElTop() {
      let elem = this.$root.$el;
      let distance = 0;
      do {
        distance += elem.offsetTop;
        elem = elem.offsetParent;
      } while (elem);
      distance = distance < 0 ? 0 : distance;
      return distance;
    },
    scrollToTop() {
      if (this.options.scrollOnReload) window.scrollTo({ top: this.getElTop(), behavior: "smooth" });
    },
  },
  watch: {
    reloading() {
      this.scrollToTop();
    },
  },
};
